import React from 'react';
import UnifiedApp from './pages/UnifiedApp';

function App() {
  return (
    <UnifiedApp />
  );
}

export default App;